export default __webpack_public_path__ + "media/images/logo-98fb114a428fc045a6fbdd6975aa1500.svg";